/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Large_Json_Files_IntroInputs */

const en_guide_large_json_files_intro = /** @type {(inputs: Guide_Large_Json_Files_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As applications grow, so does the JSON data they produce. API exports, log files, and database dumps can easily reach hundreds of megabytes. Standard tools and approaches that work for small JSON files break down at scale. This guide covers practical strategies for working with large JSON files efficiently.`)
};

const ko_guide_large_json_files_intro = /** @type {(inputs: Guide_Large_Json_Files_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`애플리케이션이 성장할수록 생성하는 JSON 데이터도 커집니다. API 내보내기, 로그 파일, 데이터베이스 덤프는 쉽게 수백 MB에 달할 수 있습니다. 작은 JSON 파일에서 잘 작동하는 표준 도구와 접근 방식은 규모가 커지면 한계에 부딪힙니다. 이 가이드는 대용량 JSON 파일을 효율적으로 다루기 위한 실용적인 전략을 다룹니다.`)
};

const ja_guide_large_json_files_intro = /** @type {(inputs: Guide_Large_Json_Files_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アプリケーションが成長するにつれ、生成するJSONデータも大きくなります。APIエクスポート、ログファイル、データベースダンプは簡単に数百メガバイトに達します。小さなJSONファイルで機能する標準的なツールやアプローチは、大規模になると破綻します。このガイドでは、大きなJSONファイルを効率的に扱うための実践的な戦略を解説します。`)
};

/**
* | output |
* | --- |
* | "As applications grow, so does the JSON data they produce. API exports, log files, and database dumps can easily reach hundreds of megabytes. Standard tools a..." |
*
* @param {Guide_Large_Json_Files_IntroInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_large_json_files_intro = /** @type {((inputs?: Guide_Large_Json_Files_IntroInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Large_Json_Files_IntroInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_large_json_files_intro(inputs)
	if (locale === "ko") return ko_guide_large_json_files_intro(inputs)
	return ja_guide_large_json_files_intro(inputs)
});